import TituloPagina from "src/components/ecabezados/TituloPagina";
import { Box } from "@mui/material";
import React from "react";
import { EstadoProyecto } from "src/redux/api/types/proyectos";
import { ListaAspirantes } from "./lista-aspirantes/ListaAspirantes";

const IndexAspirantes = () => {

  return (
    <Box sx={{ width: "100%" }}>
      <TituloPagina numeroRegistros={0} titulo="Aspirantes" />
      <br />
        <ListaAspirantes estadoProyectos={EstadoProyecto.ACTIVO} />
      
    </Box>
  );
};

export default IndexAspirantes;
